export default __webpack_public_path__ + "media/images/logo_imastodon_transparent-45d2cc66ef02a0e37f4573091ebc2625.svg";